import React, { useState, useEffect } from 'react';
import moment from 'moment-hijri'; 

// This is the package i used 
// https://www.npmjs.com/package/moment-hijri

const IslamicDate = () => {
  const [date, setDate] = useState('');

  useEffect(() => {
    const hijriMonths = [
      'Muharram', 'Safar', 'Rabi al-Awwal', 'Rabi al-Thani', 
      'Jumada al-Awwal', 'Jumada al-Thani', 'Rajab', 'Shaban', 
      'Ramadan', 'Shawwal', 'Dhul-Qadah', 'Dhul-Hijjah'
    ];

    const currentDate = moment();

    const hijriMonthIndex = currentDate.iMonth();
    const hijriDay = currentDate.iDate();
    const hijriYear = currentDate.iYear();

    // Get the corresponding Hijri month name
    const hijriMonthName = hijriMonths[hijriMonthIndex];

    const gregorianDate = currentDate.format('MMMM D, YYYY');

    const formattedDate = `${hijriMonthName} ${hijriDay}, ${hijriYear} - ${gregorianDate}`;
    setDate(formattedDate);
  }, []);

  return <div className="text-sm text-black/80 md:text-white/60">{date}</div>;
};

export default IslamicDate;
